import { Dispatch } from "redux";
import { ScheduledQualificationsSortEnum } from "../enums/ScheduledQualificationsSortEnum";
import { handleScheduledQualificationsSort } from "./handleScheduledQualificationsSort";
import { PrimaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";

interface Props {
    sort: {
        sortName: ScheduledQualificationsSortEnum;
        isSorted: boolean;
    };
    dispatch: Dispatch;
    isEstablishmentManager?: boolean;
}

export const getTableColumns = (props: Props): PrimaryTableColumn[] => {
    const { sort, dispatch, isEstablishmentManager } = props;

    return [
        ...(isEstablishmentManager
            ? [
                  {
                      value: "Naam",
                      isSortable: true,
                      isBold: true,
                      isSorted:
                          sort.sortName ===
                          ScheduledQualificationsSortEnum.EMPLOYEE_NAME_DESC,
                      sortOnClick: handleScheduledQualificationsSort({
                          sort: {
                              isSorted:
                                  sort.sortName ===
                                  ScheduledQualificationsSortEnum.EMPLOYEE_NAME_DESC,
                              sortName:
                                  ScheduledQualificationsSortEnum.EMPLOYEE_NAME_ASC,
                          },
                          dispatch,
                      }),
                  },
              ]
            : []),
        {
            value: "Kwalificatie",
            isSortable: true,
            isSorted:
                sort.sortName ===
                ScheduledQualificationsSortEnum.QUALIFICATION_NAME_DESC,
            sortOnClick: handleScheduledQualificationsSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        ScheduledQualificationsSortEnum.QUALIFICATION_NAME_DESC,
                    sortName:
                        ScheduledQualificationsSortEnum.QUALIFICATION_NAME_ASC,
                },
                dispatch,
            }),
        },
        {
            value: "Norm",
            isTag: true,
            tagColor: "#FFFFFF",
            tagBackgroundColor: "#07A9D6",
        },
        {
            value: "Opleider",
            isSortable: true,
            isSorted:
                sort.sortName ===
                ScheduledQualificationsSortEnum.EDUCATOR_NAME_DESC,
            sortOnClick: handleScheduledQualificationsSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        ScheduledQualificationsSortEnum.EDUCATOR_NAME_DESC,
                    sortName: ScheduledQualificationsSortEnum.EDUCATOR_NAME_ASC,
                },
                dispatch,
            }),
        },
        {
            value: "Startdatum",
            isSortable: true,
            isSorted:
                sort.sortName ===
                ScheduledQualificationsSortEnum.STARTS_AT_DESC,
            sortOnClick: handleScheduledQualificationsSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        ScheduledQualificationsSortEnum.STARTS_AT_DESC,
                    sortName: ScheduledQualificationsSortEnum.STARTS_AT_ASC,
                },
                dispatch,
            }),
        },
        {
            value: "Einddatum",
            isSortable: true,
            isSorted:
                sort.sortName === ScheduledQualificationsSortEnum.ENDS_AT_DESC,
            sortOnClick: handleScheduledQualificationsSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        ScheduledQualificationsSortEnum.ENDS_AT_DESC,
                    sortName: ScheduledQualificationsSortEnum.ENDS_AT_ASC,
                },
                dispatch,
            }),
        },
    ];
};
